var exports = {
  "C": "xcc377c0b--350e26--onboarding-anchor",
  "Y": "xcc377c0b--350e26--onboarding-content",
};

module.exports = exports;
